import { queryOptions } from "@tanstack/react-query";

import { ProjectHeaderName } from "@/api/ApiClientProvider";
import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";
import type { ApiQueryParams } from "@/types/api-types";

export const useAlertQueries = () => {
  const api = useApi();
  const projectId = useProjectId();

  return {
    triggeredList: (query: ApiQueryParams<"getTriggeredAlertsV1">, projectIdParam?: string | null) =>
      queryOptions({
        queryKey: QUERY_KEYS.ALERTS_TRIGGERED_LIST(query, projectIdParam ?? projectId),
        queryFn: () =>
          api.getTriggeredAlertsV1(query, {
            headers: {
              [ProjectHeaderName]: projectIdParam || "",
            },
          }),
        select: commonAPIDataSelector,
      }),
    list: () =>
      queryOptions({
        queryKey: QUERY_KEYS.ALERTS_LIST(),
        queryFn: () =>
          api.getAlertsConfigurationsV1({
            // Don't send projectId header, because we want to get all alerts, not only for the current project
            // null values are filtered out by the customFetch function
            headers: {
              [ProjectHeaderName]: "",
            },
          }),
        select: commonAPIDataSelector,
      }),
  };
};
